    <div mat-dialog-title class="!text-base">{{title}}</div>
    <div mat-dialog-content class="py-0">
        <form [formGroup]="myForm">
            <div class="grid sm:grid-cols-2 gap-x-4 gap-y-2">
                <mat-form-field class="w-full">
                    <mat-label>Nombre</mat-label>
                    <input matInput type="text" autocomplete="off" formControlName="name" required>
                    <mat-error>
                        Completa este campo.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="w-full">
                    <mat-label>Descripción</mat-label>
                    <input matInput type="text" autocomplete="off" formControlName="description">
                    <mat-error>
                        Completa este campo.
                    </mat-error>
                </mat-form-field>
                <div class="w-full flex  gap-2">
                    <mat-form-field class="flex-1">
                        <mat-label>Categorías</mat-label>
                        <mat-select disableOptionCentering multiple formControlName="categories" placeholder="Seleccione">
                            <mat-select-trigger>
                                <mat-chip-listbox class="multi">
                                    <mat-basic-chip class="chipName" *ngFor="let c of selectCategories$|async"
                                        [removable]="true" (removed)="remove(c.id)">
                                        <mat-icon matChipRemove>close</mat-icon>
                                        <span>{{c.descripcion}}</span>
                                    </mat-basic-chip>
                                </mat-chip-listbox>
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search formControlName="filterC" placeholderLabel="Buscar..."
                                    noEntriesFoundLabel="'Sin Resultados'"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option
                                *ngFor="let c of categories| search: myForm.get('filterC').value:['descripcion']"
                                [value]="c.id">{{c.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-mini-fab type="button" matTooltip="Crear categoria" color="primary"
                        style="border-radius: 15%; box-shadow: none;" class="my-2" (click)="addCategoria()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>

                <mat-form-field class="w-full">
                    <mat-label>Periodicidad</mat-label>
                    <mat-select disableOptionCentering multiple formControlName="periodicidad" placeholder="Seleccione">
                        <mat-option value="1">Lunes</mat-option>
                        <mat-option value="2">Martes</mat-option>
                        <mat-option value="3">Miércoles</mat-option>
                        <mat-option value="4">Jueves</mat-option>
                        <mat-option value="5">Viernes</mat-option>
                        <mat-option value="6">Sábado</mat-option>
                        <mat-option value="7">Domingo</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>

        <!-- Al crear, las plataformas se agregan a una lista local y se guardan junto con el programa -->
        <div *ngIf="this.data.row || addPermission">
            <div class="flex flex-row flex-wrap justify-between items-center content-center">
                <h3 style="font-size: 18px;">Plataformas</h3>
                <button type="button" mat-raised-button color="primary" class="mb-4" (click)="openDialog()"
                    *ngIf="addPermission">
                    <mat-icon>add</mat-icon>
                    Agregar
                </button>
            </div>
            <!-- <ul>
                <li *ngFor="let p of platforms">
                    <mat-checkbox [(ngModel)]="p.check" color="primary">
                        {{p.plataforma_clasificacion.plataforma.descripcion}} >
                        {{p.plataforma_clasificacion.descripcion}}: {{p.valor}}
                    </mat-checkbox>
                </li>
            </ul> -->
            <div>
                <ngx-datatable class="material" [messages]="messages" [columnMode]="'force'" [loadingIndicator]="isLoading"
                    [headerHeight]="45" [footerHeight]="45" [rowHeight]="70" [rows]="rows" [scrollbarV]="true"
                    [scrollbarH]="true" [style.height.px]="300">
                    <!-- <ngx-datatable-column name="#" [width]="10" [canAutoResize]="false" [sortable]="false" [draggable]="false">
                        <ng-template let-value="value" ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                            {{ rowIndex + 1 }}
                        </ng-template>
                    </ngx-datatable-column> -->
                    <!--<ngx-datatable-column name="Id" prop="id" [width]="70" [canAutoResize]="false" [sortable]="false"
                        [draggable]="false">
                        <ng-template let-value="value" ngx-datatable-cell-template>
                            {{ value ?? '—' }}
                        </ng-template>
                    </ngx-datatable-column>-->
                    <ngx-datatable-column name="Plataforma">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            {{row.medio_plataforma.plataforma_clasificacion.plataforma.descripcion}} >
                            {{row.medio_plataforma.plataforma_clasificacion.descripcion}}: {{row.medio_plataforma.valor}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Valor" prop="valor">
                        <ng-template let-value="value" ngx-datatable-cell-template>
                            $ {{value | dolar}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Alcance" prop="alcance">
                        <ng-template let-value="value" ngx-datatable-cell-template>
                            {{value || 0}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Acciones" prop="id" [width]="200" [canAutoResize]="false"
                        [sortable]="false">
                        <ng-template let-value="value" ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                            <button mat-stroked-button mat-button-sm color="primary" *ngIf="editPermission || !data.row" type="button"
                                (click)="edit(row)" class="me-2" matTooltip="Editar">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-stroked-button mat-button-sm *ngIf="deletePermission || !data.row" type="button"
                                (click)="removePlatform(row)" matTooltip="Eliminar">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </div>
    </div>

    <div mat-dialog-actions align="end" class="!px-6">
        <button mat-stroked-button color="primary" class="me-4" mat-dialog-close type="button">Cancelar</button>
        <!-- Un programa necesita al menos una plataforma: sin ella no se le pueden asignar contactos -->
        <span *ngIf="!isLoading && !hasPlatforms" class="me-4 text-sm text-gray-500">Agrega al menos una plataforma para guardar.</span>
        <adp-button-icon (clicked)="onSubmit()" color="primary" [disabled]="myForm.invalid || !hasPlatforms" [loading]="loading"
            label="Guardar"></adp-button-icon>
    </div>